import {
	Assessment,
	AssessmentOutlined,
	Assignment,
	AssignmentOutlined,
	GroupAdd,
	GroupAddOutlined,
	Home,
	HomeOutlined,
	People,
	PeopleOutlined,
	AutoGraph,
	AutoGraphOutlined,
	DocumentScanner,
	DocumentScannerOutlined,
} from "@mui/icons-material";
import type { SvgIconTypeMap } from "@mui/material";
import type { OverridableComponent } from "@mui/material/OverridableComponent";
import { Route, routes } from "routes";

type Icon = OverridableComponent<SvgIconTypeMap<{}, "svg">>;

export interface SideBarItem {
	route: Route;
	icons: {
		filled: Icon;
		outlined: Icon;
	};
}

export const sidebarItems: SideBarItem[] = [
	{
		route: routes,
		icons: { filled: Home, outlined: HomeOutlined },
	},
	{
		route: routes._.people,
		icons: { filled: GroupAdd, outlined: GroupAddOutlined },
	},
	{
		route: routes._.groups,
		icons: { filled: People, outlined: PeopleOutlined },
	},
	{
		route: routes._.assignments,
		icons: { filled: Assignment, outlined: AssignmentOutlined },
	},
	{
		route: routes._.trackAndReport,
		icons: { filled: Assessment, outlined: AssessmentOutlined },
	},
	{
		route: routes._.metrics,
		icons: { filled: AutoGraph, outlined: AutoGraphOutlined },
	},
	{
		route: routes._.result,
		icons: { filled: DocumentScanner, outlined: DocumentScannerOutlined },
	},
];
